export default {
	title: '传感器',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无传感器数据',
		description: '当前没有找到相关的传感器数据'
	},
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		diagnose: '诊断',
		setOffset: '设置偏移量',
		triggerAlarm: '触发报警',
		uploadWaveform: '上传波形',
		algorithmModelConfig: '算法模型配置',
		warnLevelLimit: '报警等级上限',
		refreshAlgorithmModel: '刷新算法模型',
		oneKeyTest: '一键测试'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		selectSensorWarning: '请选择传感器',
		uploadSuccess: '上传成功',
		uploadFailed: '上传失败',
		alarmTimeRequired: '请选择开始时间和结束时间',
		alarmTimeInvalid: '开始时间必须早于结束时间',
		alarmTriggerSuccess: '触发报警成功',
		confirmRefreshAlgorithmModel: '确定要刷新算法模型吗？此操作将重新生成模型配置。',
		confirmRefresh: '确认刷新',
		refreshAlgorithmModelSuccess: '刷新算法模型成功',
		fileSizeExceeded: '文件大小不能超过{size}MB',
		fileTypeNotSupported: '只支持{type}格式的文件',
		confirmTrigger: '确认触发',
		pleaseSelectAlgorithmModelGroup: '请选择算法模型组',
		pleaseSelectWarnLevelLimit: '请选择告警等级上限',
		configSuccess: '配置成功',
		paramNamePlaceholder: '请输入参数名',
		delete: '删除',
		addRow: '+ 添加一行'
	},
	form: {
		projNo: '所属项目',
		name: '测点名称',
		pointNo: '测点编号',
		deviceName: '设备名称',
		model: '型号',
		orgId: '机构 (诊断)',
		deviceId: '设备',
		direction: '安装方向',
		axisCount: '轴数',
		typeId: '测点类型',
		pointType: '业务类型',
		cylinderId: '选择气缸',
		sort: '排序',
		sensorImage: '测点图片',
		diagnoseGroupCode: '算法模型组',
		warnLevelLimit: '告警等级上限',
		configOffLineTime: '离线时间（分钟）',
		placeholder: {
			projNo: '请选择所属项目',
			name: '请输入测点名称',
			pointNo: '请输入测点编号',
			deviceName: '请输入设备名称',
			model: '请输入型号',
			orgId: '请选择机构 (诊断)',
			deviceId: '请选择设备',
			direction: '请选择安装方向',
			axisCount: '请输入轴数',
			typeId: '请选择测点类型',
			pointType: '请选择业务类型',
			cylinderId: '请选择气缸',
			sort: '请输入排序',
			diagnoseGroupCode: '请选择算法模型组',
			configOffLineTime: '请输入离线时间'
		}
	},
	table: {
		name: '测点名称',
		pointNo: '测点编号',
		deviceName: '设备名称',
		typeId: '类型',
		pointTypeName: '业务类型',
		power: '电量',
		direction: '安装方向',
		sensorStatus: '传感器状态',
		onlineStatus: '通讯状态',
		model: '型号',
		orgPath: '路径',
		diagnoseGroupCode: '算法模型组'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		close: '关闭',
		uploadWaveformTitle: '上传波形文件',
		alarmTimeRangeTitle: '选择报警时间范围',
		algorithmModelConfigTitle: '算法模型配置',
		warnLevelLimitConfigTitle: '告警等级上限设置',
		selectedSensor: '已选传感器',
		testResultTitle: '测试结果'
	},
	warnLevel: {
		general: '一般',
		medium: '中等',
		serious: '严重'
	},
	upload: {
		selectFile: '选择文件',
		dragTip: '将文件拖到此处，或',
		clickUpload: '点击上传',
		tip: '支持多个文件同时上传，最多 200 个文件，每个文件最大{size}MB',
		upload: '上传'
	},
	alarm: {
		startTime: '开始时间',
		endTime: '结束时间',
		pleaseSelectStartTime: '选择开始时间',
		pleaseSelectEndTime: '选择结束时间'
	},
	offset: {
		title: '设置偏移量',
		paramName: '参数名称',
		paramNamePlaceholder: '请输入参数名',
		delete: '删除',
		addRow: '+ 添加一行',
		columns: {
			ZA: 'Z-A',
			ZB: 'Z-B',
			XA: 'X-A',
			XB: 'X-B',
			YA: 'Y-A',
			YB: 'Y-B'
		}
	},
	testResult: {
		selectedPoints: '已选测点',
		testingSubtitle: '正在检测测点特征状态，请稍候…',
		doneSubtitle: '已完成 {count} 个测点的状态检测',
		loadingTip1: '正在下发测试指令…',
		loadingTip2: '正在采集测点特征状态…',
		loadingTip3: '正在汇总测试结果…',
		retest: '重新测试',
		copyJson: '复制JSON',
		export: '导出CSV',
		done: '测试完成',
		testTime: '测试时间',
		totalCount: '测点总数',
		online: '在线',
		offline: '离线',
		status: '状态',
		lastTime: '最近时间',
		emptyResult: '未获取到测试结果',
		failed: '测试失败，请稍后重试',
		copySuccess: '复制成功',
		exportSuccess: '导出成功'
	}
}
